export default __webpack_public_path__ + "static/media/partner-ofb.570adde8.webp";